@if (isLoading()) {
    <app-loading />
} @else {
    <app-synoptic-plan-edit-header
        [cassettes]="synopticBayPlanEditService.cassettes()"
        [hasSelectedCassette]="drawerView()?.hasSelectedCassette() ?? false"
        [hasSelection]="drawerView()?.hasSelection() ?? false"
        [planType]="PlanTypeEnum.BAY"
        [selectedNode]="selectedNode()"
        (automaticFibering)="automaticFibering($event)"
        (checkFibering)="checkFibering()"
        (leaveEditMode)="onLeaveEdition()"
        (redoFibering)="restoreUndoEdition(RestoreActionEnum.RESTORE)"
        (resetFibering)="resetFibering($event)"
        (undoFibering)="restoreUndoEdition(RestoreActionEnum.CANCEL)"
        (updatePositions)="updateCassettesPositions()"
        (validateFibering)="validateFibering()" />

    <app-tab
        #tabView
        activeTabColor="bg-background"
        [canAddTab]="true"
        [defaultTabIndex]="selectedDrawerIndex()"
        [isSimpleTabStyle]="false"
        [isTruncateAllowed]="false"
        [tabs]="bayTabs()"
        [translateTabs]="false"
        (changeTab)="selectedDrawerIndex.set($event)"
        (createTab)="createDrawer()">
        @for (drawer of synopticBayPlanEditService.drawers(); track drawer.id) {
            <ng-template appTabContent>
                @defer (on viewport) {
                    <div class="relative z-10">
                        <div class="absolute inline left-6 top-6 text-lg bg-background">
                            {{ 'synopticPlan.drawer' | transloco }} {{ drawer.code }}
                        </div>
                    </div>
                    <app-synoptic-plan-edit
                        #drawerView
                        [cassettes]="drawer.cassettes"
                        [depositId]="depositId()"
                        [drawer]="drawer"
                        [errors]="errors()"
                        [layerId]="layerId()"
                        [selectedNode]="selectedNode()"
                        [sideCables]="drawer.cables"
                        [type]="PlanTypeEnum.BAY"
                        (cassettesChange)="updateDrawerCassettes($event, drawer.id)"
                        (sideCablesChange)="updateDrawerSideCables($event, drawer.id)" />
                } @placeholder (minimum 500ms) {
                    <app-loading />
                }
            </ng-template>
        }
    </app-tab>
}
